import { FC, useEffect } from 'react';

import { useCreateWalletSettingsMutation, useGetWalletSettingsQuery } from '@entities/wallets';
import { LinearProgress } from '@mui/material';

import { WalletSettingsForm } from './WalletSettingsForm';
import { assmebleWalletSettings } from '../utils/assembleWalletSettings';

interface IProps {
  parent_id: string;
  parent_name: string;
  shouldSubmitDefaultSettings?: boolean;
  refetch: () => void;
}

export const NewWalletSettings: FC<IProps> = ({
  parent_id,
  parent_name,
  refetch,
  shouldSubmitDefaultSettings = true,
}) => {
  const [createWalletSettings] = useCreateWalletSettingsMutation();
  const { data: initialSettings, isLoading } = useGetWalletSettingsQuery(parent_id);

  useEffect(() => {
    const submitDefaultSettings = async () => {
      const settings = assmebleWalletSettings(new FormData());
      try {
        await createWalletSettings({ id: parent_id, ...settings });
        refetch();
      } catch (error) {
        console.error(error);
      }
    };
    if (shouldSubmitDefaultSettings) {
      submitDefaultSettings();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading) {
    return <LinearProgress variant='query' />;
  }

  return (
    <WalletSettingsForm
      title={`New Wallet Settings for ${parent_name}`}
      parent_id={parent_id}
      refetch={refetch}
      defaultValues={initialSettings?.data}
    />
  );
};
